module.exports = __webpack_public_path__ + "admin/img/member_avatar_male.48b02e00.png";